/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyTimeLogIntegrationInput = {|
  timelogAccountDomain: string,
  timelogAccountName: string,
  timelogAccountUserName: string,
  timelogAccountPassword: string,
  timelogAccountSiteCode: string,
  timelogAccountReportingUserName: string,
  timelogAccountReportingPassword: string,
  update: boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type verifyTimelogIntegrationMutationVariables = {|
  input: VerifyTimeLogIntegrationInput
|};
export type verifyTimelogIntegrationMutationResponse = {|
  +verifyTimeLogIntegration: ?{|
    +success: ?boolean,
    +message: ?string,
    +timeLogInitialUserMappingResponse: ?$ReadOnlyArray<?{|
      +timeLogPersonId: ?number,
      +timeLogEmail: ?string,
      +timeLogFirstName: ?string,
      +timeLogLastName: ?string,
      +linked: ?boolean,
    |}>,
    +company: ?{|
      +id: string,
      +timelogEnabled: ?boolean,
    |},
  |}
|};
export type verifyTimelogIntegrationMutation = {|
  variables: verifyTimelogIntegrationMutationVariables,
  response: verifyTimelogIntegrationMutationResponse,
|};
*/


/*
mutation verifyTimelogIntegrationMutation(
  $input: VerifyTimeLogIntegrationInput!
) {
  verifyTimeLogIntegration(input: $input) {
    success
    message
    timeLogInitialUserMappingResponse {
      timeLogPersonId
      timeLogEmail
      timeLogFirstName
      timeLogLastName
      linked
    }
    company {
      id
      timelogEnabled
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "VerifyTimeLogIntegrationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyTimeLogIntegrationPayload",
    "kind": "LinkedField",
    "name": "verifyTimeLogIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeLogUserLinkResult",
        "kind": "LinkedField",
        "name": "timeLogInitialUserMappingResponse",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLogPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLogEmail",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLogFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeLogLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "linked",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timelogEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyTimelogIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "verifyTimelogIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "verifyTimelogIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation verifyTimelogIntegrationMutation(\n  $input: VerifyTimeLogIntegrationInput!\n) {\n  verifyTimeLogIntegration(input: $input) {\n    success\n    message\n    timeLogInitialUserMappingResponse {\n      timeLogPersonId\n      timeLogEmail\n      timeLogFirstName\n      timeLogLastName\n      linked\n    }\n    company {\n      id\n      timelogEnabled\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b0eff1b36f241c625b28b6efab4a9610';

module.exports = node;
